var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEE7EF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FEE7EF",
    strokeOpacity: 0.5,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 28L23 32V29H32V27H23V24L18 28Z",
    fill: "#F31260"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0012 18.9981C27.8187 18.9948 26.6474 19.2262 25.555 19.6788C24.4625 20.1315 23.4708 20.7964 22.6372 21.6351L24.0512 23.0491C25.3732 21.7271 27.1312 20.9981 29.0012 20.9981C30.8712 20.9981 32.6292 21.7271 33.9512 23.0491C35.2732 24.3711 36.0022 26.1291 36.0022 27.9991C36.0022 29.8691 35.2732 31.6271 33.9512 32.9491C32.6292 34.2711 30.8712 35.0001 29.0012 35.0001C27.1312 35.0001 25.3732 34.2711 24.0512 32.9491L22.6372 34.3631C24.3362 36.0631 26.5962 37.0001 29.0012 37.0001C31.4062 37.0001 33.6662 36.0631 35.3652 34.3631C37.0652 32.6641 38.0022 30.4041 38.0022 27.9991C38.0022 25.5941 37.0652 23.3341 35.3652 21.6351C34.5316 20.7964 33.5399 20.1315 32.4475 19.6788C31.3551 19.2262 30.1837 18.9948 29.0012 18.9981Z",
    fill: "#F31260"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmLogout);
export default __webpack_public_path__ + "static/media/confirm-logout.16ebe689e5045ef6a101a21928fa0328.svg";
export { ForwardRef as ReactComponent };